import React from "react";
import { Section, SectionHeading } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";
import { MATERIAL_RENDER } from "@/content/homeContent";
import { MATERIAL_IMAGES_T } from "@/assets/materials";

/*
 * "La resa del materiale" — focus on layer FDM, superficie, texture, finitura.
 * Light section with the material image on a matching light frame
 * (fixes the previous light-image / dark-background contrast issue).
 * This is NOT a second color gallery: it shows how the PLA surface looks.
 */
export const MaterialRender = () => {
  return (
    <Section id="material-render-section" tone="light">
      <Reveal>
        <SectionHeading
          microLabel={MATERIAL_RENDER.microLabel}
          title={MATERIAL_RENDER.title}
          description={MATERIAL_RENDER.description}
        />
      </Reveal>

      <div className="mt-12 grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-14">
        {/* material close-up on a light, low-contrast frame */}
        <div className="lg:col-span-7">
          <Reveal delay={0.06}>
            <div
              data-testid="material-render-visual"
              className="relative aspect-[16/11] w-full overflow-hidden rounded-3xl border border-strato-gray-100 bg-strato-offwhite"
            >
              <div className="strato-fdm absolute inset-0 opacity-40" />
              <img
                src={MATERIAL_IMAGES_T["Apricot"]}
                alt="Superficie e layer FDM del PLA"
                className="absolute inset-0 h-full w-full object-contain p-8"
              />
              <span className="strato-micro absolute left-5 top-5 text-strato-graphite/45">
                MACRO · LAYER FDM
              </span>
              <span className="strato-micro absolute bottom-5 right-5 text-strato-blue">
                PLA · SATINATO
              </span>
            </div>
          </Reveal>
        </div>

        {/* focus points */}
        <div className="lg:col-span-5">
          <ul className="divide-y divide-strato-gray-100 border-y border-strato-gray-100">
            {MATERIAL_RENDER.points.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.05}>
                <li className="flex items-start gap-5 py-5">
                  <MicroLabel className="mt-1 w-8 flex-shrink-0 text-strato-gray-300">
                    {String(i + 1).padStart(2, "0")}
                  </MicroLabel>
                  <div>
                    <p className="font-display text-lg font-medium tracking-[-0.01em] text-strato-graphite">
                      {p.title}
                    </p>
                    <p className="mt-1 text-sm leading-[1.6] text-muted-foreground">
                      {p.desc}
                    </p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
};
